export default function () {
  return {
    warningTopic: {
      ru: 'Вам вынесено предупреждение за нарушение Правил форума в теме {{placeholder}}!',
      ua: 'Вам винесено попередження за порушення Правил форуму в темі {{placeholder}}!'
    },
    during30days: {
      ru: 'Обращаем ваше внимание, что повторное нарушение Правил форума приведет к понижению рейтинга вашего аккаунта и, как следствие к ограничениям в публикации сообщений вплоть до временной или постоянной блокировки аккаунта.',
      ua: 'Звертаємо вашу увагу, що повторне порушення Правил форуму призведе до зниження рейтингу вашого облікового запису та, як наслідок до обмежень в публікації повідомлень аж до тимчасового, або постійного блокування облікового запису.'
    },
    beKind: {
      ru: 'Будьте добры, ознакомьтесь с Правилами форума, прежде чем публиковать новые сообщения.',
      ua: 'Будьте ласкаві, ознайомтеся з Правилами форуму, перш ніж публікувати нові повідомлення.'
    },
    postOnModeration: {
      ru: 'Сообщение будет опубликовано после проверки администратором.',
      ua: 'Повідомлення буде опубліковано після перевірки адміністратором.'
    }
  };
}
